
import React, { useEffect, useState } from "react";
import { getFirestore, collection, getDocs, onSnapshot } from "firebase/firestore";
import app from "../../firebase";
import StudentApprovalModal from "./StudentApprovalModal";

export default function AssessmentApproval() {
  const [students, setStudents] = useState([]);
  const [archive, setArchive] = useState([]);
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [tab, setTab] = useState("approval");
  const [approvalIdFilter, setApprovalIdFilter] = useState("");
  const [approvalNameFilter, setApprovalNameFilter] = useState("");
  const [approvalDateFilter, setApprovalDateFilter] = useState("");
  const [approvalTimeFilter, setApprovalTimeFilter] = useState("all");
  const [archiveIdFilter, setArchiveIdFilter] = useState("");
  const [archiveNameFilter, setArchiveNameFilter] = useState("");
  const [archiveDateFilter, setArchiveDateFilter] = useState("");
  const [archiveTimeFilter, setArchiveTimeFilter] = useState("all");
  const [archiveStatusFilter, setArchiveStatusFilter] = useState("all");
  const rowsPerPage = 20;
  const [approvalPage, setApprovalPage] = useState(1);
  const [archivePage, setArchivePage] = useState(1);

  const clearAllFilters = () => {
    setApprovalIdFilter("");
    setApprovalNameFilter("");
    setApprovalDateFilter("");
    setApprovalTimeFilter("all");
    setArchiveIdFilter("");
    setArchiveNameFilter("");
    setArchiveDateFilter("");
    setArchiveTimeFilter("all");
    setArchiveStatusFilter("all");
    setApprovalPage(1);
    setArchivePage(1);
  };

  useEffect(() => {
    const db = getFirestore(app);
    const studentsCol = collection(db, "students");
    const unsubscribe = onSnapshot(studentsCol, (snapshot) => {
      const approvalList = [];
      const archiveList = [];
      snapshot.forEach(docSnap => {
        const data = docSnap.data();
        if (data.appointment && data.appointment.date && data.appointment.time) {
          if (data.appointment.status === "approved" || data.appointment.status === "disapproved") {
            archiveList.push({ id: docSnap.id, ...data });
          } else {
            approvalList.push({ id: docSnap.id, ...data });
          }
        }
      });
      setStudents(approvalList);
      setArchive(archiveList);
    }, (err) => {
      console.error("Error fetching students:", err);
    });
    return unsubscribe;
  }, []);

  // Remove from approval and add to archive when status changes
  const handleStatusChange = (stu, newStatus) => {
    setStudents(prev => prev.filter(s => s.id !== stu.id));
    setArchive(prev => [...prev, { ...stu, appointment: { ...stu.appointment, status: newStatus } }]);
    setSelectedStudent(null);
  };

  const filteredStudents = students.filter(stu => {
    const idMatch = (stu.idNumber?.toString() ?? "").includes(approvalIdFilter);
    const nameMatch = `${stu.firstName ?? ""} ${stu.lastName ?? ""}`.toLowerCase().includes(approvalNameFilter.toLowerCase());
    const dateMatch = !approvalDateFilter || stu.appointment?.date === approvalDateFilter;
    const timeMatch = approvalTimeFilter === "all" || (stu.appointment?.time === approvalTimeFilter);
    return idMatch && nameMatch && dateMatch && timeMatch;
  });

  const approvalTotalPages = Math.max(1, Math.ceil(filteredStudents.length / rowsPerPage));
  const displayedStudents = filteredStudents.slice((approvalPage - 1) * rowsPerPage, approvalPage * rowsPerPage);

  const filteredArchive = archive.filter(stu => {
    const idMatch = (stu.idNumber?.toString() ?? "").includes(archiveIdFilter);
    const nameMatch = `${stu.firstName ?? ""} ${stu.lastName ?? ""}`.toLowerCase().includes(archiveNameFilter.toLowerCase());
    const dateMatch = !archiveDateFilter || stu.appointment?.date === archiveDateFilter;
    const timeMatch = archiveTimeFilter === "all" || (stu.appointment?.time === archiveTimeFilter);
    const statusMatch = archiveStatusFilter === "all" || (stu.appointment?.status === archiveStatusFilter);
    return idMatch && nameMatch && dateMatch && timeMatch && statusMatch;
  });

  const archiveTotalPages = Math.max(1, Math.ceil(filteredArchive.length / rowsPerPage));
  const displayedArchive = filteredArchive.slice((archivePage - 1) * rowsPerPage, archivePage * rowsPerPage);

  return (
    <div>
      <div style={{ display: 'flex', gap: 16, marginBottom: 24 }}>
        <button onClick={() => setTab("approval")}
          style={{ background: tab === "approval" ? "#155c2b" : "#fff", color: tab === "approval" ? "#fff" : "#155c2b", border: '2px solid #155c2b', borderRadius: 6, padding: '10px 28px', fontWeight: 600, fontSize: 16, cursor: 'pointer', transition: 'background 0.2s' }}>
          Entrance Exam Approval
        </button>
        <button onClick={() => setTab("archive")}
          style={{ background: tab === "archive" ? "#155c2b" : "#fff", color: tab === "archive" ? "#fff" : "#155c2b", border: '2px solid #155c2b', borderRadius: 6, padding: '10px 28px', fontWeight: 600, fontSize: 16, cursor: 'pointer', transition: 'background 0.2s' }}>
          Entrance Exam Archive
        </button>
      </div>
      {tab === "approval" && (
        <>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 12, marginBottom: 16 }}>
            <input
              type="text"
              placeholder="Filter by ID Number"
              value={approvalIdFilter}
              inputMode="numeric"
              maxLength={10}
              onChange={(e) => { setApprovalIdFilter(e.target.value.replace(/\D/g, "").slice(0, 10)); setApprovalPage(1); }}
              style={{ padding: 10, minWidth: 180, borderRadius: 6, border: '1px solid #ccc' }}
            />
            <input
              type="text"
              placeholder="Filter by Name"
              value={approvalNameFilter}
              maxLength={20}
              onChange={(e) => { setApprovalNameFilter(e.target.value.replace(/[^\p{L}\s]/gu, "").slice(0, 20)); setApprovalPage(1); }}
              style={{ padding: 10, minWidth: 220, borderRadius: 6, border: '1px solid #ccc' }}
            />
            <input
              type="date"
              value={approvalDateFilter}
              onChange={(e) => { setApprovalDateFilter(e.target.value); setApprovalPage(1); }}
              style={{ padding: 10, minWidth: 180, borderRadius: 6, border: '1px solid #ccc' }}
            />
            <select
              value={approvalTimeFilter}
              onChange={(e) => { setApprovalTimeFilter(e.target.value); setApprovalPage(1); }}
              style={{ padding: 10, minWidth: 160, borderRadius: 6, border: '1px solid #ccc' }}
            >
              <option value="all">Time of Schedule</option>
              <option value="am">AM</option>
              <option value="pm">PM</option>
            </select>
            <button onClick={clearAllFilters}
              style={{ background: "#e67e22", color: "#fff", border: '2px solid #e67e22', borderRadius: 6, padding: '10px 20px', fontWeight: 600, fontSize: 16, cursor: 'pointer', transition: 'background 0.2s' }}>
              Clear All
            </button>
          </div>
          <table style={{ width: "100%", borderCollapse: "collapse", marginTop: 24 }}>
            <thead>
              <tr style={{ background: "#e0e0e0" }}>
                <th style={{ border: "1px solid #ccc", padding: 12, textAlign: 'center', fontWeight: 600, fontSize: 16 }}>ID Number</th>
                <th style={{ border: "1px solid #ccc", padding: 12, textAlign: 'center', fontWeight: 600, fontSize: 16 }}>Name</th>
                <th style={{ border: "1px solid #ccc", padding: 12, textAlign: 'center', fontWeight: 600, fontSize: 16 }}>Date of Schedule</th>
                <th style={{ border: "1px solid #ccc", padding: 12, textAlign: 'center', fontWeight: 600, fontSize: 16 }}>Time of Schedule</th>
                <th style={{ border: "1px solid #ccc", padding: 12, textAlign: 'center', fontWeight: 600, fontSize: 16 }}>Action</th>
              </tr>
            </thead>
            <tbody>
              {filteredStudents.length === 0 && (
                <tr><td colSpan={5} style={{ textAlign: "center", color: "#888", padding: 16 }}>No students match the current filters.</td></tr>
              )}
              {displayedStudents.map(stu => (
                <tr key={stu.id}>
                  <td style={{ border: "1px solid #ccc", padding: 12, textAlign: 'center', fontSize: 15 }}>{stu.idNumber}</td>
                  <td style={{ border: "1px solid #ccc", padding: 12, textAlign: 'center', fontSize: 15 }}>{stu.firstName} {stu.lastName}</td>
                  <td style={{ border: "1px solid #ccc", padding: 12, textAlign: 'center', fontSize: 15 }}>{stu.appointment.date}</td>
                  <td style={{ border: "1px solid #ccc", padding: 12, textAlign: 'center', fontSize: 15 }}>{stu.appointment.time === "am" ? "AM 9:00-12:00" : "PM 1:30-4:30"}</td>
                  <td style={{ border: "1px solid #ccc", padding: 12, textAlign: 'center' }}>
                    <button style={{ background: "#155c2b", color: "#fff", border: "none", borderRadius: 6, padding: "8px 18px", fontWeight: 600, fontSize: 14, cursor: "pointer", transition: 'background 0.2s' }} onMouseEnter={(e) => e.target.style.background = '#0f4620'} onMouseLeave={(e) => e.target.style.background = '#155c2b'} onClick={() => setSelectedStudent(stu)}>View</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 12, marginTop: 12 }}>
            <div style={{ color: '#555' }}>
              Showing {Math.min((approvalPage - 1) * rowsPerPage + 1, filteredStudents.length || 1)} - {Math.min(approvalPage * rowsPerPage, filteredStudents.length)} of {filteredStudents.length}
            </div>
            <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
              <button onClick={() => setApprovalPage(p => Math.max(1, p - 1))} disabled={approvalPage === 1} style={{ padding: '6px 10px' }}>Prev</button>
              <div style={{ display: 'flex', gap: 6, alignItems: 'center' }}>{Array.from({ length: approvalTotalPages }).map((_, i) => (
                <button key={i} onClick={() => setApprovalPage(i + 1)} style={{ padding: '6px 10px', background: approvalPage === i + 1 ? '#155c2b' : undefined, color: approvalPage === i + 1 ? '#fff' : undefined }}>{i + 1}</button>
              ))}</div>
              <button onClick={() => setApprovalPage(p => Math.min(approvalTotalPages, p + 1))} disabled={approvalPage === approvalTotalPages} style={{ padding: '6px 10px' }}>Next</button>
            </div>
          </div>
          {selectedStudent && (
            <StudentApprovalModal student={selectedStudent} onClose={() => setSelectedStudent(null)} onStatusChange={handleStatusChange} />
          )}
        </>
      )}
      {tab === "archive" && (
        <>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 12, marginBottom: 16 }}>
            <input
              type="text"
              placeholder="Filter by ID Number"
              value={archiveIdFilter}
              inputMode="numeric"
              maxLength={10}
              onChange={(e) => { setArchiveIdFilter(e.target.value.replace(/\D/g, "").slice(0, 10)); setArchivePage(1); }}
              style={{ padding: 10, minWidth: 180, borderRadius: 6, border: '1px solid #ccc' }}
            />
            <input
              type="text"
              placeholder="Filter by Name"
              value={archiveNameFilter}
              maxLength={20}
              onChange={(e) => { setArchiveNameFilter(e.target.value.replace(/[^\p{L}\s]/gu, "").slice(0, 20)); setArchivePage(1); }}
              style={{ padding: 10, minWidth: 220, borderRadius: 6, border: '1px solid #ccc' }}
            />
            <input
              type="date"
              value={archiveDateFilter}
              onChange={(e) => { setArchiveDateFilter(e.target.value); setArchivePage(1); }}
              style={{ padding: 10, minWidth: 180, borderRadius: 6, border: '1px solid #ccc' }}
            />
            <select
              value={archiveTimeFilter}
              onChange={(e) => { setArchiveTimeFilter(e.target.value); setArchivePage(1); }}
              style={{ padding: 10, minWidth: 160, borderRadius: 6, border: '1px solid #ccc' }}
            >
              <option value="all">Time of Schedule</option>
              <option value="am">AM</option>
              <option value="pm">PM</option>
            </select>
            <select
              value={archiveStatusFilter}
              onChange={(e) => { setArchiveStatusFilter(e.target.value); setArchivePage(1); }}
              style={{ padding: 10, minWidth: 220, borderRadius: 6, border: '1px solid #ccc' }}
            >
              <option value="all">All Status</option>
              <option value="approved">Approved</option>
              <option value="disapproved">Disapproved</option>
            </select>
            <button onClick={clearAllFilters}
              style={{ background: "#e67e22", color: "#fff", border: '2px solid #e67e22', borderRadius: 6, padding: '10px 20px', fontWeight: 600, fontSize: 16, cursor: 'pointer', transition: 'background 0.2s' }}>
              Clear All
            </button>
          </div>
          <table style={{ width: "100%", borderCollapse: "collapse", marginTop: 24 }}>
            <thead>
              <tr style={{ background: "#e0e0e0" }}>
                <th style={{ border: "1px solid #ccc", padding: 12, textAlign: 'center', fontWeight: 600, fontSize: 16 }}>ID Number</th>
                <th style={{ border: "1px solid #ccc", padding: 12, textAlign: 'center', fontWeight: 600, fontSize: 16 }}>Name</th>
                <th style={{ border: "1px solid #ccc", padding: 12, textAlign: 'center', fontWeight: 600, fontSize: 16 }}>Date of Schedule</th>
                <th style={{ border: "1px solid #ccc", padding: 12, textAlign: 'center', fontWeight: 600, fontSize: 16 }}>Time of Schedule</th>
                <th style={{ border: "1px solid #ccc", padding: 12, textAlign: 'center', fontWeight: 600, fontSize: 16 }}>Status</th>
                <th style={{ border: "1px solid #ccc", padding: 12, textAlign: 'center', fontWeight: 600, fontSize: 16 }}>Action</th>
              </tr>
            </thead>
            <tbody>
              {filteredArchive.length === 0 && (
                <tr><td colSpan={6} style={{ textAlign: "center", color: "#888", padding: 16 }}>No archived students match the selected status.</td></tr>
              )}
              {displayedArchive.map(stu => (
                <tr key={stu.id}>
                  <td style={{ border: "1px solid #ccc", padding: 12, textAlign: 'center', fontSize: 15 }}>{stu.idNumber}</td>
                  <td style={{ border: "1px solid #ccc", padding: 12, textAlign: 'center', fontSize: 15 }}>{stu.firstName} {stu.lastName}</td>
                  <td style={{ border: "1px solid #ccc", padding: 12, textAlign: 'center', fontSize: 15 }}>{stu.appointment.date}</td>
                  <td style={{ border: "1px solid #ccc", padding: 12, textAlign: 'center', fontSize: 15 }}>{stu.appointment.time === "am" ? "AM 9:00-12:00" : "PM 1:30-4:30"}</td>
                  <td style={{ border: "1px solid #ccc", padding: 12, textAlign: 'center', fontSize: 15, fontWeight: 500 }}>{stu.appointment.status ? stu.appointment.status.charAt(0).toUpperCase() + stu.appointment.status.slice(1) : ''}</td>
                  <td style={{ border: "1px solid #ccc", padding: 12, textAlign: 'center' }}>
                    <button style={{ background: "#e67e22", color: "#fff", border: "none", borderRadius: 6, padding: "8px 18px", fontWeight: 600, fontSize: 14, cursor: "pointer", transition: 'background 0.2s' }} onMouseEnter={(e) => e.target.style.background = '#d67c1c'} onMouseLeave={(e) => e.target.style.background = '#e67e22'}
                      onClick={() => setSelectedStudent({ ...stu, _archive: true })}>
                      View
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 12, marginTop: 12 }}>
            <div style={{ color: '#555' }}>
              Showing {Math.min((archivePage - 1) * rowsPerPage + 1, filteredArchive.length || 1)} - {Math.min(archivePage * rowsPerPage, filteredArchive.length)} of {filteredArchive.length}
            </div>
            <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
              <button onClick={() => setArchivePage(p => Math.max(1, p - 1))} disabled={archivePage === 1} style={{ padding: '6px 10px' }}>Prev</button>
              <div style={{ display: 'flex', gap: 6, alignItems: 'center' }}>{Array.from({ length: archiveTotalPages }).map((_, i) => (
                <button key={i} onClick={() => setArchivePage(i + 1)} style={{ padding: '6px 10px', background: archivePage === i + 1 ? '#155c2b' : undefined, color: archivePage === i + 1 ? '#fff' : undefined }}>{i + 1}</button>
              ))}</div>
              <button onClick={() => setArchivePage(p => Math.min(archiveTotalPages, p + 1))} disabled={archivePage === archiveTotalPages} style={{ padding: '6px 10px' }}>Next</button>
            </div>
          </div>
          {selectedStudent && selectedStudent._archive && (
            <StudentApprovalModal student={selectedStudent} onClose={() => setSelectedStudent(null)} onStatusChange={null} hideChecklist />
          )}
        </>
      )}
    </div>
  );
}
